import React, { useContext } from "react";
import GoalContext from "../../store/goal-context";
import classes from "./LocationItem.module.scss";
import colourClasses from "../../colour.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faCrosshairs } from '@fortawesome/free-solid-svg-icons';

const LocationItem = (props) => {
    const goalContext = useContext(GoalContext);
    const setColour = goalContext.goals[goalContext.activeGoal -1].primary_colour ? `colour--${goalContext.goals[goalContext.activeGoal -1].primary_colour}` : 'colour--black';
    const accentColour = goalContext.goals[goalContext.activeGoal -1].secondary_colour ? `colour--${goalContext.goals[goalContext.activeGoal -1].secondary_colour}` : 'colour--black--accent';
    const activeState = goalContext.activeLocation === props.locationID ? `colour--${goalContext.goals[goalContext.activeGoal -1].primary_colour}--border` : '';

    let link = props.link;
    if(!props.link.includes('http')) {
      link = `http://${props.link}`;
    }

    return (
    <div onClick={props.onClick} className={`${classes['location-item']} ${colourClasses.colour} ${colourClasses[setColour]} ${colourClasses[activeState]}`}>
        <div className={classes.offset} id={`location-${props.locationID}`}></div>
        <h3><div dangerouslySetInnerHTML={{__html: props.name}} /></h3>
        <div className={`${classes['location-description']} ${colourClasses[accentColour]}`}><div dangerouslySetInnerHTML={{__html: props.description}} /></div>
        <div className={classes['bottom-section']}>
          {
            props.link && 
            <div className={classes['website-link']}><a href={link} className={colourClasses[setColour]} target="_blank" rel="noopener noreferrer"><div className={colourClasses[accentColour]}>Visit Website</div> <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a></div>
          }
          {
              props.hasAddresses && 
              <div className={classes['view-on-map']}><div className={colourClasses[accentColour]}>View on map</div> <FontAwesomeIcon icon={faCrosshairs} /></div>
          }
        </div>
      </div>
    )
}

export default LocationItem;    